import request from "./http";

class PolicyRepository
{
    async getTransactionRulesByRoleId(roleId) {
        const path = "policy/transaction-rules/role";
        const method = "GET";
        const data = {
            role_id: roleId
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async updateTransactionRulesByRoleId(roleId, rules) {
        const path = "policy/transaction-rules/role";
        const method = "POST";
        const data = {
            role_id: roleId,
            transaction_rules: rules
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }
}

export default PolicyRepository;